import { render, staticRenderFns } from "./addpeikan.vue?vue&type=template&id=12e492b8&"
import script from "./addpeikan.vue?vue&type=script&lang=js&"
export * from "./addpeikan.vue?vue&type=script&lang=js&"
import style0 from "./addpeikan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12e492b8')) {
      api.createRecord('12e492b8', component.options)
    } else {
      api.reload('12e492b8', component.options)
    }
    module.hot.accept("./addpeikan.vue?vue&type=template&id=12e492b8&", function () {
      api.rerender('12e492b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/renwu/addpeikan.vue"
export default component.exports